import React, { useEffect, useState } from 'react';
import Select from '../formFields/Select';
import Input from '../formFields/Input';
import { Form } from './ContactUs.style';
import SendButton from './SendButton';
import TextArea from '../formFields/TextArea';
import emailjs from 'emailjs-com';

const INIT_STATE = {
  formValues: {
    type: '',
    subject: '',
    firstName: '',
    email: '',
    phoneNumber: '',
    message: '',
  },
  formErrors: {
    type: '',
    subject: '',
    firstName: '',
    email: '',
    phoneNumber: '',
    message: '',
  },
};

const REQUIRED_FIELDS = {
  type: true,
  subject: true,
  firstName: true,
  email: true,
  message: true,
};

const OPTIONS = [
  {
    value: 'project',
    label: 'Projekt',
  },
  {
    value: 'ozeElectro',
    label: 'OZE / Electromobility',
  },
];

const EMAILJS_SECRETS = {
  project: {
    id: 'service_6z4qic3',
    key: 'kuv2pPYbZjeXZE_Qj',
    templateName: 'template_p8s2juw',
  },
  ozeElectro: {
    // OLD value:
    // id: 'service_obwt9dg',
    // key: 'HvvmKn6Ga1f-y9l4R',
    // templateName: 'template_ud7nhog',

    // VALUE fromm project
    id: 'service_6z4qic3',
    key: 'kuv2pPYbZjeXZE_Qj',
    templateName: 'template_p8s2juw',
  },
};

const validation = (values, requiredFields) => {
  let isValid = true;
  const errors = { ...INIT_STATE.formErrors };
  for (const valueName in values) {
    if (requiredFields[valueName] && !values[valueName]) {
      if (isValid) {
        isValid = false;
      }
      errors[valueName] = 'This field is required!';
    }
  }

  return { isValid, errors };
};

const ContactUs = () => {
  const [emailJs, setEmailJs] = useState(null);
  const [formValues, setFormValues] = useState(INIT_STATE.formErrors);
  const [formErrors, setFormErrors] = useState(INIT_STATE.formValues);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormErrors((state) => ({
      ...state,
      [name]: '',
    }));

    setFormValues((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const handleSendEmail = async (form) => {
    const { id, key, templateName } = emailJs;

    emailjs.sendForm(id, templateName, form, key).then(
      (result) => {
        console.log(result.text);
      },
      (error) => {
        console.log(error.text);
      }
    );
  };

  const handleSubmit = (e) => {
    // e.preventDefault();
    // console.log('xxx');
    alert('Formularz zostal wyslany');
    e.target.reset();

    const { isValid, errors } = validation(formValues, REQUIRED_FIELDS);
    if (!isValid) return setFormErrors({ ...errors });

    handleSendEmail(e.target);
    setFormValues(INIT_STATE.formValues);
  };

  useEffect(() => {
    const handleSetEmailJsTarget = () => {
      if (!formValues.type) return;
      setEmailJs(EMAILJS_SECRETS[formValues.type]);
    };
    handleSetEmailJsTarget();
  }, [formValues.type]);

  return (
    <Form onSubmit={handleSubmit}>
      <Select
        value={formValues.type}
        error={formErrors.type}
        onChange={handleInputChange}
        id="type"
        name="type"
        label="Branże"
        options={OPTIONS}
        defaultDisabled
        defaultLabel="---wybierz branże---"
      />
      <Input
        type="text"
        value={formValues.subject}
        error={formErrors.subject}
        onChange={handleInputChange}
        id="subject"
        name="subject"
        label="Wiadomość"
        placeholder="Podaj temat wiadomosci"
      />
      <Input
        type="text"
        value={formValues.firstName}
        error={formErrors.firstName}
        onChange={handleInputChange}
        id="firstName"
        name="firstName"
        label="Imię"
        placeholder="Podaj imie"
      />
      <Input
        type="email"
        value={formValues.email}
        error={formErrors.email}
        onChange={handleInputChange}
        id="email"
        name="email"
        label="Email"
        placeholder="Podaj email"
      />
      <Input
        type="tel"
        value={formValues.phoneNumber}
        error={formErrors.phoneNumber}
        onChange={handleInputChange}
        id="phoneNumber"
        name="phoneNumber"
        label="Telefon"
        placeholder="Podaj numer telefonu 111222333"
        pattern="[0-9]{3}[0-9]{3}[0-9]{3}"
      />
      <TextArea
        value={formValues.message}
        error={formErrors.message}
        onChange={handleInputChange}
        id="message"
        name="message"
        label="Wiadomość"
        placeholder="Napisz cos.."
        cols="38"
        rows="8"
      />
      <SendButton type="submit" value="Wyslij" />
    </Form>
  );
};

export default ContactUs;
